import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Segmented, Space } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import PageHeader from 'components/headings/PageHeader';
import TemplateEditor from 'PDF/TemplateEditor/TemplateEditor';

const DOC_TYPES = [
  { label: 'Comprobante', value: 'comprobante' },
  { label: 'Orden', value: 'orden' },
  { label: 'Ranking Mensual', value: 'ranking_mensual' },
  { label: 'Presupuesto', value: 'presupuesto' },
  { label: 'Informe Anual', value: 'informe_anual_mantenciones' },
  { label: 'Informe de Mantención', value: 'informe_mantencion' },
];

// Vista del super-tenant (liftlogic) para editar plantillas PDF de cualquier
// tenant. Accedida desde TenantsPage → click ícono PDF en la fila del tenant.
// El TemplateEditor recibe `tenantId` para que sus calls vayan a las APIs
// admin scoped (/admin/tenants/:tenantId/pdf-templates/*).
function TenantPdfTemplatesPage() {
  const { tenantId, documentType } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentType = documentType || 'comprobante';
  // El nombre del tenant viene en location.state cuando navegamos desde
  // TenantsPage. Si se entra a la URL directo, usamos fallback "Tenant N".
  const tenantName = location.state?.tenantName || `Tenant ${tenantId}`;

  const onChangeType = (newType) =>
    navigate(`/admin/tenants/${tenantId}/pdf-templates/${newType}`, {
      state: location.state,
      replace: true,
    });

  return (
    <div style={{ padding: 16 }}>
      <PageHeader
        icon={FilePdfOutlined}
        title="Plantillas PDF"
        subtitle={`Tenant: ${tenantName}`}
        actions={<Segmented options={DOC_TYPES} value={currentType} onChange={onChangeType} />}
      />
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <TemplateEditor
          key={`${tenantId}-${currentType}`}
          documentType={currentType}
          tenantId={Number(tenantId)}
        />
      </Space>
    </div>
  );
}

export default TenantPdfTemplatesPage;
